<section class="backgroundFaq">
  <div class="row">
    <div class="col-12">
      <div class="col-12 offset-md-2 col-md-8">
        <h1 style="text-align: center; color: #d40511">
          {{ 'ACCESS.TITLE' | translate }}
        </h1>

        <!-- <hr /> -->
      </div>
      <ng-template #completePass>
        <i class="dhlicon-tick"></i>
      </ng-template>
      <!-- Bloque progreso -->
      <div class="col-12 col-md-12"
           style="padding-bottom: 30px">
        <div class="tracktrace">
          <div class="summary">
            <div class="timeline">
              <ul class="timeline-items">
                <li class="item active col-4 icon1 noPLPR">
                  <div class="icon icon1">
                    <div class="iconOption">
                      <span *ngIf="activeStep == steps.Account; else completePass">
                        1
                      </span>
                    </div>
                  </div>
                  <span class="text">{{
                    'REGISTRATION.PROGRESS_TXT1' | translate
                    }}</span>
                </li>
                <li class="line lineInactive"
                    [ngClass]="{ lineActive: activeStep > steps.Account }"></li>
                <li class="item col-4 noPLPR"
                    [ngClass]="{ active: activeStep > steps.Account }">
                  <div class="icon">
                    <div class="iconOption">
                      <span *ngIf="
                          activeStep <= steps.Signup;
                          else completePass
                        ">
                        2
                      </span>
                    </div>
                  </div>
                  <span class="text">{{
                    'REGISTRATION.PROGRESS_TXT2' | translate
                    }}</span>
                </li>
                <li class="line lineInactive"
                    [ngClass]="{ lineActive: activeStep > steps.Signup }"></li>
                <li class="item col-4 icon3 noPLPR"
                    [ngClass]="{ active: activeStep == steps.AwaitConfirmation }">
                  <div class="icon icon3">
                    <div class="iconOption">
                      <span> 3 </span>
                    </div>
                  </div>

                  <span class="text">{{ progressText }}</span>
                </li>
              </ul>
              <div class="actualStatus red col-12"
                   style="text-align: center">
                {{ currentStepText }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- bloque todavia no registrado -->
      <ng-template #notYetRegistered>
        <div class="col-12">
          <h3 class="negro"
              style="text-align: center; margin-top: 40px; margin-bottom: 20px"
              [innerHtml]="'ACCESS.REGISTERED_TXT' | translate"></h3>
        </div>
        <div class="col-12 noPLPR tickBlock">
          <ul>
            <li class="col-12 noPLPR"
                style="padding-bottom: 20px">
              <h4 class="noBold col-12 row"
                  style="text-align: justify; color: rgb(0, 0, 0, 0.9)"
                  [innerHtml]="'REGISTRATION.REGISTERED_CHECK_TXT2' | translate"></h4>
            </li>
            <li class="col-12 noPLPR"
                style="padding-bottom: 20px">
              <h4 class="noBold col-12 row"
                  style="text-align: justify; color: rgb(0, 0, 0, 0.9)"
                  [innerHtml]="'REGISTRATION.REGISTERED_CHECK_TXT1' | translate"></h4>
            </li>
          </ul>
        </div>
        <div class="col-12 noPLPR">
          <ul style="padding-left: 72px !important">
            <li class="col-12 row noPR">
              <div class="col-2 offset-1 iconFrontPage">
                <i class="dhlicon-seguimientoenvios"
                   style="margin-left: -3px;"></i>
              </div>
              <div class="col-8">
                <h4 class="red"
                    style="padding-top: 30px"
                    [innerHtml]="'ACCESS.REGISTERED_TXT_LIST1' | translate"></h4>
              </div>
            </li>
            <li class="col-12 row noPR">
              <div class="col-2 offset-1 iconFrontPage">
                <i class="dhlicon-gestiondeincidencias"
                   style="margin-left: -3px;"></i>
              </div>
              <div class="col-8">
                <h4 class="red"
                    style="padding-top: 30px"
                    [innerHtml]="'ACCESS.REGISTERED_TXT_LIST3' | translate"></h4>
              </div>
            </li>
            <li class="col-12 row noPR">
              <div class="col-2 offset-1 iconFrontPage">
                <i class="dhlicon-recogidasinternacionales"
                   style="margin-left: -3px;"></i>
              </div>
              <div class="col-8">
                <h4 class="red"
                    style="padding-top: 30px"
                    [innerHtml]="'ACCESS.REGISTERED_TXT_LIST6' | translate"></h4>
              </div>
            </li>
            <li class="col-12 row noPR">
              <div class="col-2 offset-1 iconFrontPage">
                <i class="dhlicon-facturacion"
                   style="margin-left: -3px;"></i>
              </div>
              <div class="col-8">
                <h4 class="red"
                    style="padding-top: 30px"
                    [innerHtml]="'ACCESS.REGISTERED_TXT_LIST7' | translate"></h4>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-12 noPLPR">
          <div class="row justify-content-center align-items-center text-center text-md-left">
            <div class="col-12">
              <h3 class="negro mt-3 ms-3">
                {{ 'ACCESS.DOUBT_TXT' | translate }}
              </h3>
            </div>
            <div class="col-12 row">
              <div class="col-12 col-sm-3 noPR iconoFAQ"
                   style="text-align: center">
                <img class="imgFaq"
                     src="{{ imagesDirectory }}/assets/images/faq.png"
                     alt="" />
              </div>
              <div class="col-12 col-sm-9 noPR textFAQ"
                   style="padding-left: 10px; position: relative">
                <a [href]="'SHARED.LINK_FAQ' | translate"
                   (click)="gaClickFAQ()"
                   target="_blank">
                  <h4 style="color: #666; font-weight: normal"
                      [innerHtml]="'ACCESS.DOUBTSUB_TEXT' | translate"></h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="row noPLPR">
        <div class="col-12 offset-md-1 col-md-4 desktop"
             *ngIf="! pendingRequestNonLinkedAccount">
          <ng-container *ngTemplateOutlet="notYetRegistered"> </ng-container>
        </div>
        <div class="col-12"
             [ngClass]="{
            'offset-md-1 col-md-10':  pendingRequestNonLinkedAccount,
            'col-md-5': ! pendingRequestNonLinkedAccount
          }">
          <h3 class="negro"
              style="text-align: center"></h3>
          <div class="blockForm col-12 col-md-6">
            <form #frm="ngForm"
                  class="col-12"
                  (ngSubmit)="onSubmit()">
              <fieldset [disabled]="activeStep > steps.Account"
                        [ngStyle]="{
                  display:  pendingRequestNonLinkedAccount ? 'none' : null
                }">
                <h4>{{ 'REGISTRATION.FORM_QUESTION1' | translate }}</h4>
                <div class="row">
                  <div class="form-group col-12 col-md-6">
                    <input #codeControl="ngModel"
                           #inputCode
                           [focus]="true"
                           name="request.Account.Code"
                           [(ngModel)]="request.Account.Code"
                           class="form-control"
                           [placeholder]="'PROFILE.ACCOUNT_NUMBER' | translate"
                           [maxlength]="10"
                           (input)="keydownCode(inputCode.value)"
                           required
                           [errorMessage]="'REGISTRATION.ACCOUNT_ERROR' | translate" />
                    <span *ngIf="request.Account.Code?.length > 6 || (request.Account.Code && isNaN(Number(request.Account.Code)))"
                          class="invalid-label">{{ 'REGISTRATION.ACCOUNT_LENGTH_ERROR' | translate }}</span>
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <ng-select #agencyControl="ngModel"
                               name="request.Account.Agency"
                               [(ngModel)]="request.Account.Agency"
                               [placeholder]="'PROFILE.PROVINCE' | translate"
                               [items]="agencies$ | async"
                               bindValue="Code"
                               [notFoundText]="'SHARED.NOT_FOUND' | translate"
                               bindLabel="Name"
                               [disabled]="activeStep > steps.Account"
                               [selectOnTab]="true"
                               required>
                    </ng-select>
                  </div>
                </div>
              </fieldset>
              <fieldset #commonFieldSet="fieldset"
                        [disabled]="activeStep != steps.Signup"
                        [ngStyle]="{
                  display:  pendingRequestNonLinkedAccount ? 'none' : null
                }">
                <h4>{{ 'REGISTRATION.FORM_QUESTION2' | translate }}</h4>
                <div class="row noPLPR">
                  <div class="form-group col-12 col-md-6">
                    <input name="request.Name"
                           [focus]="activeStep == steps.Signup"
                           [(ngModel)]="request.Name"
                           class="form-control"
                           [placeholder]="'PROFILE.NAME' | translate"
                           maxlength="40"
                           required
                           [errorMessage]="
                        'REGISTRATION.NAME_ERROR' | translate
                      " />
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <input name="request.Surname"
                           [(ngModel)]="request.Surname"
                           class="form-control"
                           [placeholder]="'PROFILE.SURNAMES' | translate"
                           maxlength="40"
                           required
                           [errorMessage]="
                        'REGISTRATION.SURNAME_ERROR' | translate
                      " />
                  </div>
                </div>
                <div class="row noPLPR">
                  <div class="form-group col-12 col-md-6">
                    <input #phoneControl="ngModel"
                           name="request.PhoneNumber"
                           number
                           [(ngModel)]="request.PhoneNumber"
                           class="form-control"
                           [placeholder]="'REGISTRATION.CONTACT_PHONE' | translate"
                           required
                           [errorMessage]="invalidPhoneLength ? ('PROFILE_RESOURCES.INVALID_PHONE' | translate) : 
                           ('REGISTRATION.PHONE_ERROR' | translate)" />
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <input class="form-control"
                           name="request.Department"
                           [placeholder]="'PROFILE.DEPARTMENT' | translate"
                           [(ngModel)]="request.Department"
                           required
                           maxlength="50"
                           [errorMessage]="
                        'REGISTRATION.DEPARTMENT_ERROR' | translate
                      " />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <input name="request.Email"
                           class="form-control"
                           [(ngModel)]="request.Email"
                           [placeholder]="'PROFILE.EMAIL' | translate"
                           maxlength="60"
                           required
                           [errorMessage]="
                      'REGISTRATION.EMAIL_ERROR' | translate
                    "
                           [pattern]="EMAIL_REGEX" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <input name="confirmEMail"
                           [(ngModel)]="confirmEMail"
                           class="form-control"
                           [placeholder]="'REGISTRATION.CONFIRM_EMAIL' | translate"
                           maxlength="60"
                           [compareEqual]="request.Email"
                           required
                           [pattern]="EMAIL_REGEX"
                           [errorMessage]="
                      'REGISTRATION.EMAIL_NOT_MATCH_ERROR' | translate
                    " />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <common-password-editor name="request.Password"
                                            [errorMessage]="passwordValidationMessage"
                                            [(ngModel)]="request.Password"
                                            [placeholder]="'PROFILE.PASSWORD' | translate"
                                            [disabled]="activeStep != steps.Signup"
                                            required
                                            [pattern]="passwordRegex">
                    </common-password-editor>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <common-password-editor name="passwordConfirmation"
                                            [(ngModel)]="passwordConfirmation"
                                            [placeholder]="'PROFILE.PASSWORD_CONFIRMATION' | translate"
                                            [compareEqual]="request.Password"
                                            required
                                            [errorMessage]="'REGISTRATION.PASSWORD_NOT_MATCH_ERROR' | translate">
                    </common-password-editor>
                  </div>
                </div>
                <div class="form-group">
                  <comun-checkbox name="rememberPassword"
                                  [textTag]="'ACCESS.REMEMBER_PASSWORD_TXT' | translate"
                                  [(ngModel)]="rememberPassword">
                  </comun-checkbox>
                </div>
                <div class="form-group">
                  <div class="col-12">
                    <comun-checkbox name="request.AcceptsPrivacyPolicy"
                                    [textTag]="'REGISTRATION.PRIVACY_TXT' | translate"
                                    [(ngModel)]="request.AcceptsPrivacyPolicy"
                                    required
                                    [errorMessage]="
                        'REGISTRATION.ACCEPT_PRIVACY_POLICY' | translate
                      "
                                    [errorsElement]="messageAcceptPrivacyPolicy">
                    </comun-checkbox>
                  </div>
                  <div class="col-12">
                    <span [style.display]="
                        this.enterClicked &&
                        !this.request.AcceptsPrivacyPolicy
                          ? 'inline'
                          : 'none'
                      "
                          #messageAcceptPrivacyPolicy
                          class="invalid-label"></span>
                    </div>
                </div>

                <div class="form-group">
                  <comun-checkbox name="request.AcceptsInfo"
                                  [textTag]="'REGISTRATION.ACCEPT_MAIL_TXT' | translate"
                                  [(ngModel)]="request.AcceptsInformation">
                  </comun-checkbox>
                </div>
                <div class="form-group">
                  <div class="col-12 noPLPR d-grid btnSendStatus">
                    <input [type]="linked ? 'button' : 'submit'"
                           [disabled]="activeStep != steps.Signup"
                           [value]="'REGISTRATION.SIGN_UP_BTN' | translate"
                           class="btn"
                           (click)="onEnterClick()" />
                  </div>
                </div>
              </fieldset>
              <!-- Bloque paso 2  -->
              <fieldset *ngIf="linked"
                        [ngStyle]="{
                  display:
                     pendingRequestNonLinkedAccount &&
                    activeStep == steps.Signup
                      ? null
                      : 'none'
                }">
                <div class="col-12 noPLPR">
                  <h3 style="text-align: center">
                    {{ 'REGISTRATION.STEP2HEADER_TEXT' | translate }}
                  </h3>
                  <p>{{ 'REGISTRATION.STEP2TEXT' | translate }}</p>
                  <div class="blockForm col-12 noPLPR">
                    <div class="col-12 blockForm2">
                      <div class="form-group row">
                        <comun-checkbox name="acceptAdminShipping"
                                        [textTag]="
                            'REGISTRATION.STEP2CHECK_TEXT' | translate
                          "
                                        [(ngModel)]="acceptsAdminSending"
                                        required
                                        [errorMessage]="
                            'REGISTRATION.ACCEPT_ADMIN_SEND' | translate
                          "
                                        [errorsElement]="messageAcceptAdminShipping">
                        </comun-checkbox>
                        <span #messageAcceptAdminShipping
                              class="invalid-label"></span>
                      </div>
                      <div class="form-group">
                        <div class="row justify-content-center btnSendStatus"
                             style="margin-top: 4rem">
                          <input type="submit"
                                 [value]="
                              'REGISTRATION.SENDREQUEST_BTN' | translate
                            "
                                 class="col-12 col-md-8 btn btn-default btn-block" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <!-- Bloque paso 3 -->
              <div class="col-12 noPLPR"
                   *ngIf="linked && activeStep == steps.AwaitConfirmation">
                <div class="col-12"
                     style="text-align: center">
                  <h3 style="text-align: center">
                    {{ 'REGISTRATION.STEP3HEADER_TEXT' | translate }}
                  </h3>
                  <p>{{ 'REGISTRATION.STEP3TEXT' | translate }}</p>
                  <img style="text-align: center"
                       style="max-width: 400px"
                       class="img-responsive"
                       src="{{
                      imagesDirectory
                    }}/assets/images/composicion_dhl.png"
                       alt="fin-proceso-Signup-dhl" />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-12 col-md-5 mobile">
          <ng-container *ngTemplateOutlet="notYetRegistered"> </ng-container>
        </div>
      </div>
      <!-- modal Cuenta no existe -->
      <ng-template #doesNotExistModal>
        <common-header-modal [modalRef]="modalRef"></common-header-modal>
        <div class="modal-body row">
          <div class="col-12 noPLPR">
            <div class="col-12 offset-md-2 col-md-8">
              <h4 class="red"
                  style="text-align: center"
                  [innerHtml]="'REGISTRATION.USER_NOT_EXIST_TXT' | translate"></h4>
              <p [innerHtml]="'REGISTRATION.USER_NOT_EXIST_TXTP' | translate"></p>
              <div class="col-12 offset-md-2 col-md-8 btnSendStatus">
                <a [href]="'SHARED.URL_CONTACT_ROUTE' | translate"
                   class="btn btn-default btn-block">
                  {{ 'REGISTRATION.REQUEST_INFO_BTN' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- modal introducir NIF -->
      <ng-template #nifModal>
        <common-header-modal [modalRef]="modalRef"></common-header-modal>
        <div class="modal-body row">
          <div class="col-12 noPLPR">
            <div class="col-12 offset-md-1 col-md-10">
              <p>{{ 'REGISTRATION.TXT_INTRO_NIF' | translate }}</p>
              <div class="col-12">
                <div class="row">
                  
                <div class="form-group col-12 col-md-9 mb-3">
                  <div class="row">
                  <label for=""
                         class="col-3">{{
                    'PROFILE.NIF' | translate
                    }}</label>
                  <div class="col-9">
                    <input name="request.Nif"
                           class="form-control inputRegistrationModal"
                           [placeholder]="'PROFILE.NIF' | translate"
                           [(ngModel)]="request.Nif" />
                  </div>

                  </div>
                </div>
                <div class="form-group col-12 col-md-3 noPR btnSendStatus text-end"
                     style="margin-top: 0">
                  <button class="btn btn-default btn-block"
                          (click)="requestSignup()">
                    {{ 'SHARED.ACCEPT' | translate }}
                  </button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- modal ya casi esta -->
      <ng-template #reviewEmailModal>
        <common-header-modal [modalRef]="modalRef"></common-header-modal>
        <div class="modal-body row">
          <div class="col-12 noPLPR">
            <div class="col-12 offset-md-1 col-md-10"
                 style="text-align: center">
              <h3 [innerHtml]="'REGISTRATION.ALMOST_FINISHED_TXT' | translate"></h3>
              <p [innerHtml]="'REGISTRATION.ALMOST_FINISHED_TXTP' | translate"></p>
              <div class="col-12 offset-md-2 col-md-8 btnSendStatus">
                <input type="button"
                       [value]="'REGISTRATION.CLOSE_BTN' | translate"
                       (click)="modalRef.hide()"
                       class="btn btn-default btn-block" />
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>